// lodash is a declared dependency; the `debounce` package only arrives through
// vue-tables-2's own dependency tree
import debounce from 'lodash/debounce';

/**
 * Builds the search handler for the header-action search box (shown while rows
 * are selected): one server search per pause in typing, using the latest input.
 * `.cancel()` drops a search still waiting to run.
 *
 * Create it once per component. A debounce made inside the event handler gets a
 * fresh timer on every keystroke and never actually waits (PS-10475 QA).
 *
 * Pass the real input event: vue-tables-2's serverSearch reads event.target and
 * treats a plain object as a date-filter payload.
 */
export default function debouncedSearch(tableInstance) {
    return debounce(function(event) {
        tableInstance.serverSearch(event);
    }, tableInstance.opts.debounce);
}



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/methods/debounced-search.js